import { useEffect } from 'react'

import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryReportAccessGrants } from '../../models/useQueryReportAccessGrants'

export interface IUseReportAccessGrantListPresenterParams {
  secondaryCategoryId: number
}

export const useReportAccessGrantListPresenter = ({
  secondaryCategoryId,
}: IUseReportAccessGrantListPresenterParams) => {
  const intl = useProcurifyIntl()

  const { grants, isLoading, error } =
    useQueryReportAccessGrants(secondaryCategoryId)

  useEffect(() => {
    if (error) {
      toast.error({
        title: intl.formatMessage(messages.fetchErrorToastTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.fetchErrorToastMessage),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return {
    data: {
      grants,
    },
    states: {
      isLoading,
    },
  }
}
